/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {isNull, isUndefined} from 'lodash';
import {globalGroupAncestorAccountIdsSelector} from '@/store/selectors/global-group-chooser-selectors';

/**
 * The useAncestorIds hook Returns Ancestor Ids collection.
 *
 * ```typescript
 *  const {ancestorAccountIds} = useAncestorIds();
 * ```
 */
export const useAncestorIds = (): number[] => {
  const ancestorAccountId = useSelector(globalGroupAncestorAccountIdsSelector);
  const [ancestorAccountIds, setAncestorAccountIds] = useState();

  useEffect(() => {
    let getAncestorAccountValue;
    let ancestorIds;
    if (!isNull(ancestorAccountId)) {
      getAncestorAccountValue = Object.values(ancestorAccountId)[0];
      if (!isUndefined(getAncestorAccountValue)) {
        ancestorIds  = Object.keys(getAncestorAccountValue).toString();
      }
      setAncestorAccountIds(ancestorIds);
    }
  }, [ancestorAccountId]);

  return ancestorAccountIds;
};
